import React from 'react';
import { Align } from '@progress/kendo-react-popup';
import { Moment } from 'moment';
import {
    FieldDefinitionFieldTypeNumeric,
    PartialDateTimeIgnore,
    PrimitiveValues,
} from '@components-clean/core/study-data-filter/study-data-filter.interfaces';

export interface AdvancedSelectProps {
    anchor?: HTMLElement | null;
    show: boolean;
    dataType: FieldDefinitionFieldTypeNumeric;
    anchorAlign?: Align;
    popupAlign?: Align;
    onCancel: () => void;
    onSelect: (data: AdvanceSelectFilter) => void;
    ref: React.Ref<HTMLDivElement | null>;
}

export type ValueLabel<T> = {
    value: T;
    label: string;
};

export type GroupOperatorItem = ValueLabel<LogicOperator>;
export type OperatorItem = ValueLabel<Operator>;

export type FormValues = {
    operator1: OperatorItem;
    value1: PrimitiveValues | ValueLabel<boolean | null>;
    operator2: OperatorItem;
    value2: PrimitiveValues | ValueLabel<boolean | null>;
    groupOperator: GroupOperatorItem;
};

export type AdvanceSelectFilter = {
    logic: LogicOperator | null;
    filters: SelectValue[];
};

export type SelectValue = {
    operator: Operator | null;
} & (NumericValue | DateValue | BoolValue | TextValue);

export type NumericValue = {
    dataType:
        | FieldDefinitionFieldTypeNumeric.Int
        | FieldDefinitionFieldTypeNumeric.Float
        | FieldDefinitionFieldTypeNumeric.Long;
    value: number | null;
};

export type DateValue = {
    dataType: FieldDefinitionFieldTypeNumeric.Date | FieldDefinitionFieldTypeNumeric.PartialDate;
    subType?: PartialDateTimeIgnore;
    value: Moment | string | null;
};

export type BoolValue = {
    dataType: FieldDefinitionFieldTypeNumeric.Bool;
    value: boolean | null;
};

export type TextValue = {
    dataType: FieldDefinitionFieldTypeNumeric.Text;
    value: string | null;
};

export enum Operator {
    Equals,
    NotEqual,
    Null,
    NotNull,
    Contains,
    NotContains,
    GreaterThan,
    GreaterThanOrEqualTo,
    LessThan,
    LessThanOrEqualTo,
}

export enum LogicOperator {
    AND,
    OR,
}
